<template>
	<Loading v-if="!ready" />
	<div v-else>
		<h2> {{ mem.Name }} </h2>
		<h4> Appears in {{mem['Number of Performances']}} production{{mem['Number of Performances']===1?'':'s'}}</h4>
		<b-card-group columns>
			<CardPerformance v-for="p in performances" :rec="p"/>
		</b-card-group>
	</div>
</template>

<script>

import Vuex from 'vuex'

import CardPerformance from './CardPerformance.vue'
import Loading from '../Loading.vue'

export default {
	name: 'FeatureCastMember',
	components: { CardPerformance, Loading },
	computed: Vuex.mapState({
		mem: state => state.featured.member.member,
		performances: state => state.featured.member.performances,
		ready: state => state.featured.member.ready
	}),
	created: function() {
		if(this.$store.state.featured.member.member.id !== this.$route.params.id) {
			this.$store.dispatch('featured/load', {
				type: 'CAST',
				id: this.$route.params.id,
			})
		}
	}
}

</script>
